/*  eslint-disable */
import { batch } from 'react-redux';

import { API_EXPLORE_URL, HIDDEN_BOOK_IDS } from '../constants';
import { callApi } from '../utils';
import { setItems } from './threads';

const collectionContainsHiddenBook = collection =>
  collection.books?.results?.some(book =>
    HIDDEN_BOOK_IDS.includes(book.id)
  );
import {
  exploreRecentColsThreadId,
  exploreFeaturedColsThreadId,
  exploreRecsThreadId,
  exploreReviewsThreadId,
} from '../selectors/explore';

export function fetchExplore({ dispatch, token }) {
  return callApi(API_EXPLORE_URL, { token }).then(data => {
    const {
      recommended,
      reviews,
      recentCollections,
      featuredCollections,
    } = data;
    const filteredRecent = recentCollections?.results?.filter(
      c => !collectionContainsHiddenBook(c)
    );
    const filteredFeatured = featuredCollections?.results?.filter(
      c => !collectionContainsHiddenBook(c)
    );
    batch(() => {
      dispatch(setItems(exploreRecsThreadId, recommended?.results));
      dispatch(setItems(exploreFeaturedColsThreadId, filteredFeatured));
      dispatch(setItems(exploreReviewsThreadId, reviews?.results));
      dispatch(setItems(exploreRecentColsThreadId, filteredRecent));
    });
  });
}
